import {
  alpha,
  ButtonBase,
  Button,
  Chip,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Iconify from "../iconify/Iconify";
import { SLOT_STATUS_META } from "../../pages/trainer/trainerUtils";

export default function TrainerCalendarControls({
  calendarView,
  isMobile,
  rangeLabel,
  rangeSummary,
  onNavigate,
  onToday,
  onToggleCalendarView,
}) {
  const theme = useTheme();
  const showTextButtons = useMediaQuery(theme.breakpoints.up("lg"));
  const previousLabel =
    calendarView === "week" ? "Vorige Woche" : "Voriger Monat";
  const nextLabel =
    calendarView === "week" ? "Nächste Woche" : "Nächster Monat";
  const toggleLabel =
    calendarView === "week" ? "Monatsansicht" : "Wochenansicht";
  const outlinedButtonSx = {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 2,
    minWidth: 0,
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        px: { xs: 1.5, md: 2 },
        py: 1.25,
        borderRadius: 3,
        borderColor: alpha(theme.palette.divider, 0.6),
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={showTextButtons ? 0.75 : 0.25}
        >
          {showTextButtons ? (
            <Button
              size="small"
              variant="outlined"
              startIcon={<Iconify icon="mdi:chevron-left" width={20} />}
              onClick={() => onNavigate(-1)}
              sx={outlinedButtonSx}
            >
              {previousLabel}
            </Button>
          ) : (
            <IconButton size="small" onClick={() => onNavigate(-1)}>
              <Iconify icon="mdi:chevron-left" width={22} />
            </IconButton>
          )}
          <ButtonBase
            onClick={onToday}
            sx={{ px: 1, py: 0.25, borderRadius: 1.5 }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 700,
                whiteSpace: "nowrap",
                fontSize: { xs: "0.9rem", md: "1rem" },
              }}
            >
              {rangeLabel}
            </Typography>
          </ButtonBase>
          {showTextButtons ? (
            <Button
              size="small"
              variant="outlined"
              endIcon={<Iconify icon="mdi:chevron-right" width={20} />}
              onClick={() => onNavigate(1)}
              sx={outlinedButtonSx}
            >
              {nextLabel}
            </Button>
          ) : (
            <IconButton size="small" onClick={() => onNavigate(1)}>
              <Iconify icon="mdi:chevron-right" width={22} />
            </IconButton>
          )}
        </Stack>

        <Stack direction="row" spacing={0.75} alignItems="center">
          {!isMobile && (
            <Stack direction="row" spacing={0.5}>
              <Chip
                size="small"
                label={`${rangeSummary.open} offen`}
                sx={{
                  backgroundColor: SLOT_STATUS_META.open.bg,
                  color: SLOT_STATUS_META.open.text,
                  fontWeight: 600,
                  fontSize: "0.7rem",
                  height: 22,
                }}
              />
              <Chip
                size="small"
                label={`${rangeSummary.mine} meine`}
                sx={{
                  backgroundColor: SLOT_STATUS_META.mine.bg,
                  color: SLOT_STATUS_META.mine.text,
                  fontWeight: 600,
                  fontSize: "0.7rem",
                  height: 22,
                }}
              />
            </Stack>
          )}
          {showTextButtons ? (
            <Button
              size="small"
              variant="outlined"
              startIcon={
                <Iconify
                  icon={
                    calendarView === "week"
                      ? "mdi:calendar-month-outline"
                      : "mdi:calendar-week-outline"
                  }
                  width={20}
                />
              }
              onClick={onToggleCalendarView}
              sx={outlinedButtonSx}
            >
              {toggleLabel}
            </Button>
          ) : (
            <Tooltip title={toggleLabel}>
              <IconButton
                size="medium"
                color="primary"
                onClick={onToggleCalendarView}
                sx={outlinedButtonSx}
              >
                <Iconify
                  icon={
                    calendarView === "week"
                      ? "mdi:calendar-month-outline"
                      : "mdi:calendar-week-outline"
                  }
                  width={20}
                />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Stack>
    </Paper>
  );
}
